import { render, staticRenderFns } from "./common-footer.vue?vue&type=template&id=43a270ac&scoped=true&"
import script from "./common-footer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./common-footer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./common-footer.vue?vue&type=style&index=0&id=43a270ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a270ac",
  null
  
)

export default component.exports